.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 0 1.6rem;
  flex: 1;
  order: 2;

  @media screen and (min-width: $bp-medium) {
    gap: 0.8rem;
    padding: 1.6rem;
    order: 1;
  }
}
